import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Form, Toggle, Message, useToaster } from 'rsuite';
import { updateSettingAutoComplete } from '@/services/setting.service';

const AuthorizationPopup = ({ open, onClose, name, settingsId, initialAutoAccept }) => {
  const { t } = useTranslation();
  const toaster = useToaster();
  const [formValue, setFormValue] = useState({
    allowDirectValidation: false
  });

  useEffect(() => {
    if (initialAutoAccept && Array.isArray(initialAutoAccept)) {
      const entry = initialAutoAccept.find(item => item.name === name);
      setFormValue({
        allowDirectValidation: entry ? entry.active : false
      });
    }
  }, [initialAutoAccept, name]);

  const handleSave = async () => {
    try {
      const updatedAutoAccept = initialAutoAccept
        ? initialAutoAccept.map(item =>
            item.name === name ? { ...item, active: formValue.allowDirectValidation } : item
          )
        : [{ name, active: formValue.allowDirectValidation }];

      console.log('Updating with settingsId:', settingsId, 'data:', {
        autoAccept: updatedAutoAccept.filter(item => item.name === name)
      });
      const result = await updateSettingAutoComplete(settingsId, { autoAccept: updatedAutoAccept });
      console.log('Update result:', result);

      toaster.push(
        <Message type="success" duration={3000}>
          {t('Authorization updated successfully!')}
        </Message>,
        { placement: 'topCenter' }
      );
      onClose();
    } catch (error) {
      console.error('Update Error:', error);
      toaster.push(
        <Message type="error" duration={3000}>
          {t('Authorization could not be updated')}
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  return (
    <Modal open={open} onClose={onClose} style={{ marginTop: '60px' }}>
      <Modal.Header>
        <Modal.Title>{t('Authorization for Third-Party Site Request')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form fluid>
          <Form.Group>
            <Form.ControlLabel>
              {t('Enable Direct Auto-Approval of Third-Party Requests')}
              <Form.HelpText tooltip>
                {t(
                  'If this option is enabled, requests will be automatically set to validated upon submission. If disabled, requests will follow the standard approval process and require manual validation.'
                )}
              </Form.HelpText>
            </Form.ControlLabel>
            <Toggle
              onChange={(checked, event) =>
                setFormValue(prev => ({ ...prev, allowDirectValidation: checked }))
              }
              checked={formValue.allowDirectValidation}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="subtle">
          {t('Cancel')}
        </Button>
        <Button onClick={handleSave} appearance="primary">
          {t('Save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AuthorizationPopup;
